export default "__VITE_ASSET__BccqjIkX__"